import type { SelectedCompany, UserCompany } from '../contexts/UserContext';

export interface ModelSlugCompanyResolution {
  companyId: string | undefined;
  companyName: string | undefined;
  matchedBy: 'kryspace_slug' | 'selected_fallback' | 'none';
}

/** Resolve which company owns trees for a kryspace workspace model slug (e.g. prime_ops under Central). */
export function resolveCompanyForModelSlug(
  modelSlug: string | undefined,
  selectedCompany: SelectedCompany | null,
  availableCompanies: UserCompany[]
): ModelSlugCompanyResolution {
  const slug = modelSlug?.trim().toLowerCase();
  if (!slug) {
    return {
      companyId: selectedCompany?.id,
      companyName: selectedCompany?.name,
      matchedBy: selectedCompany?.id ? 'selected_fallback' : 'none',
    };
  }

  const match = availableCompanies.find(
    (row) => row.company.kryspace_slug?.trim().toLowerCase() === slug
  );
  if (match) {
    return {
      companyId: match.company.id,
      companyName: match.company.name,
      matchedBy: 'kryspace_slug',
    };
  }

  return {
    companyId: selectedCompany?.id,
    companyName: selectedCompany?.name,
    matchedBy: selectedCompany?.id ? 'selected_fallback' : 'none',
  };
}
